import { inject, Injectable } from "@angular/core";
import { StateContext } from "@ngxs/store";
import { TableStateModel } from "../table.state.model";
import { Pagination } from "@core/models/pagination.model";
import { TableActions } from "../table.actions";
import { IdentityLogService } from "@core/services/identity-log.service";

@Injectable({
  providedIn: 'root',
})
export class IdentityHandler {

    constructor() {}
    identityService = inject(IdentityLogService);

    handleIdentityLogsLoad(ctx: StateContext<TableStateModel>, params: Pagination) {
        this.identityService.getIdentityLogs({ ...params }).subscribe({
          next: (response) => {
            ctx.dispatch(
              new TableActions.LoadTableDataSuccess({
                tableKey: 'identityLog',
                data: response.data?.data,
                totalCount: response.data?.total_count,
              })
            );
          },
          error: (error) => {
            ctx.dispatch(
              new TableActions.LoadTableDataFailure({
                tableKey: 'identityLog',
                error: error.message,
              })
            );
          },
        });
      }

      filterIdentityLogList(
        ctx: StateContext<TableStateModel>,
        action: TableActions.FilterReferralList
      ) {
        return this.identityService
          .getIdentityLogs(undefined, action.payload.filter)
          .subscribe({
            next: (response) => {
              ctx.dispatch(
                new TableActions.LoadTableDataSuccess({
                  tableKey: 'identityLog',
                  data: response.data?.data,
                  totalCount: response.data?.total_count,
                })
              );
            },
            error: (error) => {
              ctx.dispatch(
                new TableActions.LoadTableDataFailure({
                  tableKey: 'identityLog',
                  error: error.message,
                })
              );
            },
          });
      }

     

     
}


